import React, { useEffect, useState } from 'react';
import 'devextreme/dist/css/dx.light.css';
import TagList from '../../components/tag/TagList';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation, useParams } from 'react-router-dom';
import { fetchTagListAPI } from '../../store/tags/action';
import { ComponentLoading } from '../../components/loading';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import i18n, { supportedLanguages } from '../../services/i18n';
import AppTagHeader from '../../components/layout/AppTagHeader';
import { fetchApplicationList } from '../../store/application/action';
import ApplicationList from '../../components/application/ApplicationList';

const Dashboard = () => {
  const { lang } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { app, tag } = useSelector((state) => state);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedSectionInd, setSelectedSectionInd] = useState(0);

  useEffect(() => {
    const langCode = lang;
    const langLower = langCode.toLowerCase();
    if (supportedLanguages.some((l) => l.toLowerCase() === langLower)) {
      i18n.changeLanguage(langCode);
    } else {
      i18n.changeLanguage('en');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (
      tag?.tagList?.OpenTagsCount +
        tag?.tagList?.RepliedTagCount +
        tag?.tagList?.ReplyAwaitedCount ===
      0
    ) {
      setSelectedSectionInd(1);
    }
  }, [tag?.tagList]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([fetchTagListAPI(dispatch), fetchApplicationList(dispatch)]);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const RenderLottieAnimation = () => (
    <div className="flex h-[calc(100vh-100px)] w-full flex-col items-center justify-center">
      <DotLottieReact
        autoplay
        loop={false}
        className="w-[800px]"
        src="https://lottie.host/4e16b383-93a2-4449-9893-60d51ed0712d/uihvnlnBtN.lottie"
      />
    </div>
  );

  return (
    <AnimatePresence>
      <motion.div
        exit={{ opacity: 0 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div>
          <div className="sticky top-0 z-10 bg-white">
            <AppTagHeader
              type="dashboard"
              selectedSectionInd={selectedSectionInd}
              setSelectedSectionInd={setSelectedSectionInd}
            />
          </div>

          {isLoading ? (
            <ComponentLoading loading={isLoading} className="mt-3" />
          ) : (
            <div className="overflow-x-auto px-6 pb-2 pt-4">
              <AnimatePresence>
                {selectedSectionInd === 0 && (
                  <div>
                    {tag?.tagList?.OpenTagsCount +
                      tag?.tagList?.RepliedTagCount +
                      tag?.tagList?.ReplyAwaitedCount !==
                    0 ? (
                      <TagList tagList={tag?.tagList} />
                    ) : (
                      <RenderLottieAnimation />
                    )}
                  </div>
                )}
                {selectedSectionInd === 1 && (
                  <div>
                    {app?.applicationList?.length !== 0 ? (
                      <ApplicationList applicationList={app?.applicationList} />
                    ) : (
                      <RenderLottieAnimation />
                    )}
                  </div>
                )}
              </AnimatePresence>
            </div>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Dashboard;
